export default __webpack_public_path__ + "static/media/last_anima_min.c69fdb98.mp4";